<!--
Copyright (c) 2020 ForgeRock. All rights reserved.

This software may be modified and distributed under the terms
of the MIT license. See the LICENSE file for details.
-->

<template>
    <b-alert show>
        {{$t('pages.selfservice.registration.emailValidation')}}
    </b-alert>
</template>

<script>
/**
 * @description Stage for handling email validation
 *
 **/
export default {
    name: 'Email-Validation'
};
</script>
